<template>
  <BaseLayout>
    <v-container fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg6>
          <ProtocolForm
            v-model="protocol"
            @submit="save"
            :backLink="{ name: 'protocols' }"
            title="Protokoll erstellen"
            submitText="Erstellen"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </BaseLayout>
</template>

<script>
import Protocol from '@/models/protocol';

export default {
  name: 'NewProtocol',
  requireSuperuser: true,
  data() {
    return {
      protocol: new Protocol({ is_published: true }),
    };
  },
  methods: {
    async save() {
      await this.protocol.save();
      this.$showSnackbar({ text: 'Protokoll erfolgreich erstellt.', color: 'success' });
      this.$router.push({ name: 'protocols' });
    },
  },
};
</script>
